export default __webpack_public_path__ + "static/03-a8a8ea82f3d6c7bfe323d3c8183440d2.jpg";